module.exports = __webpack_public_path__ + "img/@thumb_samsunglife.1cdb5c25.png";